import { SimpleOption } from '../types/basicOption';

const documentCategories: Array<SimpleOption> = [
  { label: 'Kategorie auswählen', value: '' },
  { label: 'Arztbrief stationär', value: 'doctor_letter_inpatient' },
  { label: 'Arztbrief ambulant', value: 'doctor_letter_outpatient' },
  { label: 'Gutachten', value: 'assessment' },
  { label: 'Rechnung', value: 'bill' },
  { label: 'Rezept', value: 'recipe' },
  { label: 'Unterschriebenes Rezept', value: 'signed_prescription' },
  { label: 'Überweisung', value: 'transfer' },
  { label: 'Datenschutzerklärung', value: 'privacy_policy' },
  { label: 'Datenverarbeitungsvereinbarung', value: 'data_processing_agreement' },
  { label: 'AGB', value: 'agb' },
  { label: 'Aufklärung', value: 'enlightenment' },
  { label: 'Information über privatärztliche Behandlung', value: 'private_medical_treatment' },
  { label: 'Personalausweis', value: 'id' },
  { label: 'Reisepass', value: 'passport' },
  { label: 'Krankenkassenkarte', value: 'health_insurance_card' },
  { label: 'Sonstiges', value: 'miscellaneous' },
  { label: 'ProPharma Rezept', value: 'propharma_debug_file' },
];
export default documentCategories;
